import 'owl.carousel';

$(".owl-carousel").owlCarousel({
    autoWidth: true,
    dots: false
    // dotsContainer: '.bullets__list'
});
